/* eslint-disable no-restricted-imports */
import { useCallback } from 'react';
import { EditablePersonInfo, usePersonInfo } from '@/data/Content/PersonInfo';
import { Switch } from '@/utils/switch';
import { convertDateToBackendFormat } from '@/data/utils/convertDateToBackendFormat';

export const useUpdatePreferredSizes = () => {
	const {
		savePersonInfo,
		personInfo,
		isLoading: isLoadingPersonInfo,
		mutatePersonInfo,
		mapPersonInfo,
	} = usePersonInfo();

	const onUpdatePreferredSizes = useCallback(
		async (data: Record<string, string>) => {
			const gender = Object.entries(data).find(([label]) => label === 'GENDER')?.[1];
			const birthday = Object.entries(data).find(([label]) => label === 'BIRTHDAY')?.[1];
			const { personInfo: _personInfo } = mapPersonInfo(await mutatePersonInfo());
			const dateOfBirth = birthday
				? convertDateToBackendFormat(birthday)
				: _personInfo?.dateOfBirth;

			await savePersonInfo(
				{
					..._personInfo,
					firstName: _personInfo?.firstName,
					lastName: _personInfo?.lastName,
					lastNameMat: _personInfo?.lastNameMat,
					dateOfBirth,
					gender: gender
						? Switch(gender)
								.case('Masculino', () => 'Male')
								.case('Femenino', () => 'Female')
								.case('Prefiero no decirlo', () => 'Unspecified')
								.defaultTo(() => _personInfo?.gender)
						: _personInfo?.gender,
					x_userProfileField1: JSON.stringify(
						Object.entries(data)
							.filter(([label]) => label !== 'GENDER')
							.map(([label, value]) => ({
								label,
								value,
							}))
					),
				} as EditablePersonInfo,
				true
			);
		},
		[mapPersonInfo, mutatePersonInfo, savePersonInfo]
	);

	return {
		personInfo,
		isLoadingPersonInfo,
		onUpdatePreferredSizes,
	};
};
